import gcalendar from './gcalendar.png';
import './styles.css';

function buildICS({ title, description, location, start, end }) {
  const fmt = d =>
    d.getFullYear().toString().padStart(4, '0') +
    (d.getMonth() + 1).toString().padStart(2, '0') +
    d.getDate().toString().padStart(2, '0') + 'T' +
    d.getHours().toString().padStart(2, '0') +
    d.getMinutes().toString().padStart(2, '0') +
    d.getSeconds().toString().padStart(2, '0');

  const uid = `evt-${Date.now()}@bodagalvezbarrios.com`;
  const dtstamp = fmt(new Date());

  const ics =
    `BEGIN:VCALENDAR
    VERSION:2.0
    PRODID:-//bodagalvezbarrios//AddToCalendar//ES
    CALSCALE:GREGORIAN
    METHOD:PUBLISH
    BEGIN:VEVENT
    UID:${uid}
    DTSTAMP:${dtstamp}
    DTSTART:${fmt(start)}
    DTEND:${fmt(end)}
    SUMMARY:${title}
    DESCRIPTION:${description?.replace(/\n/g, "\\n") ?? ""}
    LOCATION:${location ?? ""}
    END:VEVENT
    END:VCALENDAR`.replace(/\n/g, '\r\n');

  return ics;
}

function downloadICS(ics, filename = 'evento.ics') {
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function toGoogleDateUTC(d) {
  const z = new Date(d.getTime());
  return z.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}

export default function AddToCalendar() {
  const startGT = new Date('2026-11-21T12:00:00-06:00');
  const endGT = new Date('2026-11-21T21:00:00-06:00');

  const title = 'Boda Gálvez Barrios';
  const description = 'Misa y recepción de la boda Gálvez Barrios.';
  const location = 'Monte San Francisco, La Floresta Event Center';

  const googleHref =
    'https://calendar.google.com/calendar/render' +
    `?action=TEMPLATE&text=${encodeURIComponent(title)}` +
    `&dates=${toGoogleDateUTC(startGT)}/${toGoogleDateUTC(endGT)}` +
    `&details=${encodeURIComponent(description)}` +
    `&location=${encodeURIComponent(location)}` +
    `&sf=true&output=xml`;

  return (
    <section className="schedule-section">
      <div className="schedule">
        <button
          className="calendar-btn"
          onClick={() => {
            const ics = buildICS({ title, description, location, start: startGT, end: endGT });
            downloadICS(ics, 'bodagalvezbarrios.ics');
          }}
        >
          Agregar a mi calendario
        </button>

        <span className="separator-text">o</span>

        <button
          className="calendar-btn gcal-btn"
          onClick={() => { window.open(googleHref, '_blank'); }}
        >
          <img src={gcalendar} alt="Google Calendar" className="gcal-icon" />
          Agregar a Google Calendar
        </button>
      </div>
    </section>
  );
}